/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
/* eslint-disable import/prefer-default-export */
type AddressData = {
  address?: string;
  number?: string;
  city?: string;
  zip?: string;
  province?: string;
  nation?: string;
};

export const formatAddress = (data: AddressData): string => {
  const { address, number, city, zip, province, nation } = data || {};

  const addr = `${address || ''} ${number || ''}`.trim();
  const cityAndZip = `${zip || ''} ${city || ''}`.trim();
  let addrAndCity: string;
  if (addr !== '') {
    if (cityAndZip !== '') addrAndCity = `${addr}, ${cityAndZip}`;
    else addrAndCity = `${addr},`;
  } else addrAndCity = `${cityAndZip}`;
  const prov = province ? `(${province})` : '';
  return `${addrAndCity} ${prov} ${nation || ''}`.trim();
};